export function renderYhteenvetoToimenpideBlock({ content, groupedToimenpiteet }) {
  if (!groupedToimenpiteet) return;

  const flattenGrouped = (grouped) =>
    Object.values(grouped || {}).flatMap(catArr => catArr || []);

  const immediateItems = flattenGrouped(groupedToimenpiteet.immediate);
  const significantItems = flattenGrouped(groupedToimenpiteet.significant);

  const categoryOrder = [
    "Rakennetekniikka",
    "LVI Järjestelmät",
    "Sähköjärjestelmät",
    "Lisätutkimukset",
    "Muu",
  ];

  const groupByCategory = (items) =>
    items.reduce((acc, item) => {
      const cat = item.category?.trim() || "Muu";
      if (!acc[cat]) acc[cat] = [];
      acc[cat].push(item);
      return acc;
    }, {});

  const groupedImmediate = groupByCategory(immediateItems);
  const groupedSignificant = groupByCategory(significantItems);

  const fixChars = (str) => str.replace(/⁰/g, "°");

  const renderItemList = (items) => {
    for (const i of items) {
      const text = fixChars((i.text || "").trim());
      if (!text) continue;
      content.push({ text: "• " + text, style: "list" });
    }
  };
  
  // --- Välittömästi korjattavat ---
  if (immediateItems.length > 0) {
    content.push({ text: "Välittömästi korjattavat:", bold: true, style: "paragraph" });

    for (const cat of categoryOrder) {
      const items = groupedImmediate[cat] || [];
      if (!items.length) continue;

      content.push({ text: cat, style: "paragraph" });
      renderItemList(items);
    }
  }

  // --- Merkittävät toimenpiteet ---
  if (significantItems.length > 0) {
    content.push({ text: "Merkittävät toimenpiteet:", bold: true, style: "paragraph" });

    for (const cat of categoryOrder) {
      const items = groupedSignificant[cat] || [];
      if (!items.length) continue;

      content.push({ text: cat, style: "paragraph" });
      renderItemList(items);
    }
  }

  // Optional placeholder
  if (!immediateItems.length && !significantItems.length) {
    content.push({ text: "Ei toimenpide-ehdotuksia saatavilla.", style: "paragraph", color: "#666" });
  }

  // Debug logs
  console.log("immediateItems", immediateItems.map(i => i.category + ": " + i.text));
  console.log("significantItems", significantItems.map(i => i.category + ": " + i.text));
  console.log('groupedImmediate', groupedImmediate);
  console.log('groupedSignificant', groupedSignificant);
}